import type { ComponentProps, PropsWithChildren } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import { backgroundColor as bg, display } from 'styled-system';
import type { BackgroundColorProps, DisplayProps } from 'styled-system';

import { Flex } from 'common/components/Flex';
import type { FlexProps } from 'common/components/Flex';
import type { Color } from 'common/theme/colors/types';
import { boxSizing } from 'common/theme/system-utilities';
import type { BoxSizingProps } from 'common/theme/system-utilities';
import type { BannerProps } from '../../../types';

interface MobileTextBoxProps extends Partial<BannerProps>, PropsWithChildren {
  isTextMissing?: boolean;
}

const Container = styled(Flex)<FlexProps & BackgroundColorProps & BoxSizingProps & DisplayProps>`
  ${bg};
  ${display};
  ${boxSizing};
`;

const containerStyles: ComponentProps<typeof Container> = {
  width: '100%',
  px: ['sp_16', 'sp_24'],
  py: ['sp_24'],
  boxSizing: 'border-box',
  display: ['flex', null, 'none'],
};

const MobileTextBox = ({ children, backgroundColor, isTextMissing }: MobileTextBoxProps) => {
  if (isTextMissing) return null;

  return (
    <Container {...containerStyles} bg={(backgroundColor ?? 'white') as Color}>
      {children}
    </Container>
  );
};

export default MobileTextBox;
